import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_admon, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import { JsonDependencias } from '../../../Helpers/JsonToOneLevel';
import ModalService from '../../../ModalService/ModalService';
import AlertForm from '../../../../../../Services/AlertForm';
import FormularioDependencia from './FormularioDependencia';

const ModalAddDependencias = ({ openAdd, setOpenAdd, agregar, errorTable, informacionAdicional, nombreModulo  }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarDependencia = ( dependencia ) => {
        axios.post( `${servicios_grupogack_admon}/compania`, dependencia, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:
                        agregar( JsonDependencias(respuesta.data.dataResponse) );
                        setOpenAdd( false );
                        break;
                    case 400:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        //errorTable( respuesta.data.msg );
                        break;
                    default:
                        errorTable( registro_no_guardado );
                        break;
                }
            })
            .catch( error => {
                errorTable( registro_no_guardado );
            })
    }

    return (
        <ModalService title="Nueva Dependencia" parentNode={nombreModulo} minWidth="40%"
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
                <FormularioDependencia
                    error={error}
                    informacion={informacionAdicional}
                    enviarDependencia={enviarDependencia}
                />
        </ModalService>
    );
};

export default ModalAddDependencias;